var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-container-small"},[_c('Welcome',{attrs:{"me":_vm.$store.state.me,"welcomeChecklist":_vm.$store.state.welcome_checklist}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }